import axios from 'axios';

// export const API_URL = 'http://127.0.0.1:8000'
// export const WS_URL = 'ws://127.0.0.1:8000'

// export const API_URL = 'https://api.test-kasper.ru'
// export const WS_URL = 'wss://api.test-kasper.ru'

// export const API_URL = 'https://api.applovirds.pro'
// export const WS_URL = 'wss://api.applovirds.pro'

export const API_URL = 'https://api.lovirds.ru'
export const WS_URL = 'wss://api.lovirds.ru'

// Проверка токена
export const APIVerifyToken = async (token, params={}, platform) => {
    try {
        const config = getAuthConfig(token, platform);
        const response = await axios.get(`${API_URL}/api/verify-token/`, { ...params, ...config });
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== Чаты Мессенджера =====

// Создать чат с пациентом
export const APICreateChatWithPatient = async (patientId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/create-with-patient/`,
      { patient_id: patientId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить чаты
export const APIGetChats = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить сообщения чата по ID с пагинацией
export const APIGetChatMessagesById = async (chatId, token, limit = 30, offset = 0) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/${chatId}/messages/?limit=${limit}&offset=${offset}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отправка сообщения в чат
export const APISendMessage = async (chatId, messageData, token, attachments = []) => {
  try {
    const formData = new FormData();
    
    // Добавляем текстовые данные
    formData.append('content', messageData.content);
    // formData.append('type_sender', 'doctor');
    // formData.append('chat_user', messageData.chat_user);
    
    // Добавляем вложения
    attachments.forEach((file, index) => {
      formData.append(`attachments`, file);
    });
    
    // Let the browser add the multipart boundary; JSON headers break file uploads.
    const config = getAuthConfig(token);
    config.headers = { ...config.headers };
    delete config.headers['Content-Type'];
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/send-message/`,
      formData,
      config
    );
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// WebSocket подключение к потоку сообщений
export const createWebSocketConnection = (chatId, token, onMessageCallback, onStatusChange) => {
  let socket = null;
  let reconnectTimer = null;
  let stopped = false;
  let reconnectAttempts = 0;
  const maxReconnectAttempts = 5;
  const baseReconnectDelay = 5000;

  const scheduleReconnect = () => {
    if (stopped || reconnectTimer !== null || reconnectAttempts >= maxReconnectAttempts) return;
    const delay = baseReconnectDelay * (++reconnectAttempts);
    reconnectTimer = setTimeout(() => {
      reconnectTimer = null;
      connect();
    }, delay);
  };

  const connect = () => {
    if (stopped) return;
    const platform = localStorage.getItem('authPlatform') || 'tg';
    const current = new WebSocket(`${WS_URL}/chatws/${chatId}/?token=${token}&platform=${platform}`);
    socket = current;
    const isCurrent = () => !stopped && socket === current;

    current.onopen = () => {
      if (!isCurrent()) return;
      reconnectAttempts = 0;
      onStatusChange?.(true);
    };

    current.onmessage = (e) => {
      if (!isCurrent()) return;
      try {
        onMessageCallback(JSON.parse(e.data));
      } catch (error) {
        console.error('Ошибка обработки сообщения WebSocket:', error);
      }
    };

    current.onclose = (e) => {
      if (!isCurrent()) return;
      onStatusChange?.(false);
      if (!e.wasClean) scheduleReconnect();
    };

    current.onerror = () => {
      if (!isCurrent()) return;
      onStatusChange?.(false);
    };
  };

  const close = () => {
    stopped = true;
    if (reconnectTimer !== null) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    if (socket) {
      // Prevent late events and reconnects after switching chats or unmounting.
      socket.onopen = null;
      socket.onmessage = null;
      socket.onclose = null;
      socket.onerror = null;
      if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
        socket.close(1000, 'User left the chat');
      }
    }
  };

  connect();

  return {
    // Keep the original socket accessor, but always expose the current connection.
    get socket() { return socket; },
    close,
    isConnected: () => !stopped && socket?.readyState === WebSocket.OPEN,
  };
};


// ===== Профили =====


// Создане базового профиля
export const APICreateBaseProfile = async (token, data) => {
    try {
        const platform = localStorage.getItem('authPlatform') || 'tg';
        const response = await axios.post(
            `${API_URL}/api/profile/create-basic/`,
            data,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'X-Platform': platform,
                // Не указываем Content-Type для FormData — axios сам подставит
              }
            }
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновить профиль
export const APIUpdateBaseProfile = async (token, existingProfileId, data) => {
    try {
      const platform = localStorage.getItem('authPlatform') || 'tg';
      const response = await axios.patch(
        `${API_URL}/api/profile/update/${existingProfileId}/`,
        data,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
            'X-Platform': platform,
          }
        }
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
};

// Получить состояния профиля по ID
export const APIGetProfileStatus = async (token, userId) => {
    try {
        const response = await axios.get(
          `${API_URL}/api/profile/status/${userId}/`,
          getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получить профиль по ID
export const APIGetProfile = async (token) => {
    try {
        const response = await axios.get(
          `${API_URL}/api/profile/`,
          getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновление предпочтений партнера
export const APIUpdatePartnerPreferences = async (token, profileId, preferences) => {
    try {
        const response = await axios.patch(
            `${API_URL}/api/profile/update-partner/${profileId}/`,
            preferences,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// ===== Лента =====


// Получение профилей с пагинацией
export const APIGetProfiles = async (token, page = 1, pageSize = 10, extra = {}) => {
    try {
        const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
        if (extra.sortBy) params.set('sort_by', extra.sortBy);
        if (extra.minCompatibility != null && Number(extra.minCompatibility) > 0) params.set('min_compatibility', String(extra.minCompatibility));
        if (extra.traits) params.set('traits', extra.traits);
        const response = await axios.get(
            `${API_URL}/api/profiles/?${params.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        // Обрабатываем ошибку модерации отдельно
        if (error.response?.status === 423) {
            return {
                profiles: [],
                view_only_mode: true,
                error: error.response.data.error
            };
        }
        handleApiError(error);
        throw error;
    }
};

// Лайк профиля
export const APILikeProfile = async (token, likedProfileId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/profiles/like/`,
            { liked_user_id: likedProfileId }, // поле оставлено как есть, но содержит Profile.id
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Суперлайк профиля (ожидает Profile.id, не User.id)
export const APISuperLikeProfile = async (token, likedProfileId, isSuperLike = true) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/profiles/super-like/`,
            {
              liked_user_id: likedProfileId, // поле оставлено как есть, но содержит Profile.id
              is_super_like: isSuperLike
            },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Запрос контакта (ожидает Profile.id, не User.id)
export const APIRequestContact = async (token, contactedProfileId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/profiles/contact/`,
            { contacted_user_id: contactedProfileId }, // поле оставлено как есть, но содержит Profile.id
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};



// ===== Метчи =====

// Получить метчи
export const APIGetMatches = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/matches/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Подтвердить взаимную симпатию
export const APIConfirmMutualLove = async (token, interactionId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/matches/confirm/`,
            { interaction_id: interactionId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создать чат для метча
export const APICreateMatchChat = async (token, interactionId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/matches/create-chat/`,
            { interaction_id: interactionId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// Получить все хобби
export const APIGetHobbies = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/hobbies/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получить все сферы деятельности
export const APIGetFieldsOfActivity = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/fields-of-activity/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== Жалобы =====

// Создать жалобу
export const APICreateComplaint = async (token, complaintData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/complaints/`,
      complaintData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить мои жалобы
export const APIGetMyComplaints = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/complaints/my/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить детали жалобы
export const APIGetComplaintDetail = async (token, complaintId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/complaints/${complaintId}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ===== Предложения =====

// Создать предложение
export const APICreateSuggestion = async (token, suggestionData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/suggestions/`,
      suggestionData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить мои предложения
export const APIGetMySuggestions = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/suggestions/my/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить детали предложения
export const APIGetSuggestionDetail = async (token, suggestionId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/suggestions/${suggestionId}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Союзы =====

// Получить список союзов
export const APIGetUnions = async (token, page = 1, pageSize = 10) => {
  try {
    const response = await axios.get(
      `${API_URL}/unions/?page=${page}&page_size=${pageSize}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить мои союзы
export const APIGetMyUnions = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/unions/my/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить детали союза
export const APIGetUnionDetail = async (token, unionId) => {
  try {
    const response = await axios.get(
      `${API_URL}/unions/${unionId}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать союз
export const APICreateUnion = async (token, unionData) => {
  try {
    const response = await axios.post(
      `${API_URL}/unions/create/`,
      unionData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить посты союза
export const APIGetUnionPosts = async (token, unionId, page = 1, pageSize = 10) => {
  try {
    const response = await axios.get(
      `${API_URL}/unions/${unionId}/posts/?page=${page}&page_size=${pageSize}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Лайкнуть союз
export const APILikeUnion = async (token, unionId, isLike = true) => {
  try {
    const response = await axios.post(
      `${API_URL}/unions/${unionId}/like/`,
      { is_like: isLike },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Лайкнуть пост союза
export const APILikeUnionPost = async (token, postId) => {
  try {
    const response = await axios.post(
      `${API_URL}/unions/posts/${postId}/like/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать комментарий к посту союза
export const APICreateUnionPostComment = async (token, postId, content, parentCommentId = null) => {
  try {
    const response = await axios.post(
      `${API_URL}/unions/posts/${postId}/comments/create/`,
      { content, parent_comment: parentCommentId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Обновить союз
export const APIUpdateUnion = async (token, unionId, unionData) => {
  try {
    const response = await axios.patch(
      `${API_URL}/unions/${unionId}/update/`,
      unionData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать пост в союзе
export const APICreateUnionPost = async (token, unionId, postData) => {
  try {
    const platform = localStorage.getItem('authPlatform') || 'tg';
    const response = await axios.post(
      `${API_URL}/unions/${unionId}/posts/create/`,
      postData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          'X-Platform': platform,
        }
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Удалить пост союза
export const APIDeleteUnionPost = async (token, postId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/unions/posts/${postId}/delete/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const APIEndUnion = async (token, unionId) => {
  try {
    const response = await axios.post(
      `${API_URL}/unions/${unionId}/end/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ===== Фильтрация и поиск чатов =====

// Поиск чатов с фильтрами
export const APISearchChats = async (token, filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    // Добавляем фильтры в параметры
    if (filters.type && filters.type !== 'all') {
      params.append('type_chat', filters.type === 'community' ? 'community' : 'default');
    }
    if (filters.city) {
      params.append('city', filters.city);
    }
    if (filters.memberCount) {
      // Преобразуем в числовые диапазоны для бэкенда
      switch(filters.memberCount) {
        case 'small':
          params.append('min_members', 2);
          params.append('max_members', 10);
          break;
        case 'medium':
          params.append('min_members', 10);
          params.append('max_members', 50);
          break;
        case 'large':
          params.append('min_members', 50);
          break;
      }
    }
    if (filters.tags && filters.tags.length > 0) {
      params.append('tags', filters.tags.join(','));
    }
    if (filters.searchText) {
      params.append('search', filters.searchText);
    }

    const response = await axios.get(
      `${API_URL}/chat/search-communities/?${params.toString()}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Поиск по тегам
export const APISearchByTags = async (token, tag) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/community-by-tag/${encodeURIComponent(tag)}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение популярных тегов
export const APIGetPopularTags = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/popular-tags/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Универсальный поиск по всем чатам и сообщениям
export const APISearchAllChats = async (token, searchQuery) => {
  try {
    const params = new URLSearchParams();
    params.append('search', searchQuery);
    
    const response = await axios.get(
      `${API_URL}/chat/search-by-tag/?${params.toString()}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Создание сообщества
export const APICreateCommunity = async (token, communityData) => {
  try {
    const platform = localStorage.getItem('authPlatform') || 'tg';
    const response = await axios.post(
      `${API_URL}/chat/create-community/`,
      communityData,
      {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
              'X-Platform': platform,
          },
          timeout: 30000
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Обновление сообщества
export const APIUpdateCommunity = async (token, communityId, communityData) => {
  try {
    const platform = localStorage.getItem('authPlatform') || 'tg';
    const response = await axios.patch(
      `${API_URL}/chat/update-community/${communityId}/`,
      communityData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          'X-Platform': platform,
        }
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получение деталей сообщества
export const APIGetCommunityDetail = async (token, communityId) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/community/${communityId}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Получить ссылку для приглашения
export const APIGetChatInviteLink = async (token, chatId) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/get-invite-link/${chatId}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить чат по slug
export const APIGetChatBySlug = async (token, slug) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/get-by-slug/?slug=${slug}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Добавить пользователя в чат
export const APIAddChatUser = async (token, chatId, userData) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/add-user/`,
      userData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Получить участников чата
export const APIGetChatUsers = async (token, chatId) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/${chatId}/users/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Заблокировать пользователя в чате
export const APIBlockChatUser = async (token, chatId, userId, blockData) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/block-user/${userId}/`,
      blockData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить все подсказки для сообществ
export const APIGetAllCommunitySuggestions = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/all-community-suggestions/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить подсказки для конкретного поля
export const APIGetCommunitySuggestions = async (token, field) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/community-suggestions/?field=${field}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Получить список тарифов
export const APIGetTariffPlans = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/tariffs/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создать платеж для тарифа
export const APICreateTariffPayment = async (token, paymentData) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/tariffs/payment/create/`,
            paymentData,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Проверить статус платежа
export const APICheckPaymentStatus = async (token, paymentUuid) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/payments/${paymentUuid}/status/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Получить информацию о тарифе пользователя
export const APIGetUserTariffInfo = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/api/tariffs/user-info/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Обновить номер телефона пользователя
export const APIUpdateUserPhone = async (token, phone) => {
    try {
        const response = await axios.patch(
            `${API_URL}/api/user/phone/`,
            { phone },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Покупка лайков
export const APIPurchaseLikes = async (token, likesPacks) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/purchase/likes/`,
      { likes_packs: likesPacks },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Покупка суперлайков
export const APIPurchaseSuperLikes = async (token, superLikesPacks) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/purchase/super-likes/`,
      { super_likes_packs: superLikesPacks },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Комбинированная покупка
export const APIPurchaseCombinedLikes = async (token, likesPacks, superLikesPacks) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/purchase/combined-likes/`,
      { 
        likes_packs: likesPacks,
        super_likes_packs: superLikesPacks 
      },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};




export const APITelegramLogin = async (userData) => {
    try {
        const response = await axios.post(`${API_URL}/api/telegram-login/`, userData);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


// ===== Вспомогательные функции =====

// Обработка ошибок API
const handleApiError = (error) => {
  if (error.code === 'ECONNABORTED') {
    console.error('Запрос превысил лимит ожидания.');
  } else if (error.code === 'ERR_NETWORK') {
    console.error('Ошибка сети.');
  } else if (error.response) {
    console.error('Ошибка сервера:', error.response.status, error.response.data);
  } else {
    console.error('Произошла ошибка:', error.message);
  }
};

// Создание конфигурации axios с токеном авторизации
export const getAuthConfig = (token, platform) => {
  // Если платформу явно не передали — берём из localStorage
  const resolvedPlatform = platform || localStorage.getItem('authPlatform') || 'tg';
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-Platform': resolvedPlatform,
    }
  };
};

export const APIGetAdminStats = async (token, period = '30d') => {
    try {
        const response = await axios.get(
            `${API_URL}/api/admin/stats/?period=${period}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};


export const APIGetMyReferral = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/api/referral/me/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};